/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

export {OverlayOutsideClickDispatcher} from './overlay-outside-click-dispatcher';
export {OverlayKeyboardDispatcher} from './overlay-keyboard-dispatcher';
